import { getTenderAttachment } from '~src/services/api';
import { saveFromLink } from '~src/utils/downloader/shared/saveFromLink';
import { DownloadingState, useStore } from '~src/store';

export const downloadAttachment = async (
  file: string | { id: string },
  projectId: number | undefined,
  tenderId: string,
  onDownloadStarted?: () => unknown
) => {
  const fileLocation = await getTenderAttachment({
    tenderId,
    projectId: String(projectId),
    attachmentId: typeof file === 'string' ? file : file.id,
  });

  if (fileLocation) {
    useStore.getState().changeDownloadingState(DownloadingState.DOWNLOADING);
    onDownloadStarted && onDownloadStarted();
    saveFromLink(fileLocation.location, fileLocation.title);
  }

  useStore.getState().changeDownloadingState(DownloadingState.FINISHING);
  setTimeout(() => {
    useStore.getState().changeDownloadingActive(false);
  }, 3_000);
};
